import React from 'react';
export const CTASection = () => {
  return <div id="visit-store" className="w-full bg-gray-100 py-12 px-4 md:px-8" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <div className="bg-black p-6 rounded-lg" data-id="element-27">
          <div className="flex flex-col items-center" data-id="element-28">
            <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-29">
              WELCOME TO FRZN
            </h3>
            <div className="flex flex-col sm:flex-row gap-4 mb-4" data-id="element-30">
              <div className="flex items-center text-white" data-id="element-31">
                <svg className="w-5 h-5 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-32">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-33" />
                </svg>
                <span data-id="element-34">Premium Quality</span>
              </div>
              <div className="flex items-center text-white" data-id="element-35">
                <svg className="w-5 h-5 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-36">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-37" />
                </svg>
                <span data-id="element-38">Fast USA Shipping</span>
              </div>
              <div className="flex items-center text-white" data-id="element-39">
                <svg className="w-5 h-5 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-40">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-41" />
                </svg>
                <span data-id="element-42">30-Day Returns</span>
              </div>
            </div>
            <a href="#" className="inline-block bg-white text-black font-bold px-8 py-3 rounded-full text-lg hover:bg-gray-200 transition-colors w-full sm:w-auto text-center" data-id="element-43">
              VISIT OUR STORE →
            </a>
          </div>
        </div>
      </div>
    </div>;
};